import React from "react";
import { Reveal } from "../shared/Reveal";

const PARTNERS = ["bepartner", "skyworth", "solavita", "ohms", "ecs"];

export default function Partners() {
  const track = [...PARTNERS, ...PARTNERS];
  return (
    <section className="partners">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">OUR PARTNERS &amp; GROUP</Reveal>
        <Reveal className="h2" tag="div">A Growing Family of <span className="g">Global Partners</span></Reveal>
      </div>
      <div className="marquee">
        <div className="track">
          {track.map((p, i) => (
            <div className="pcard" key={i} data-testid={`partner-${i}`}>
              <img src={`/brand/${p}.png`} alt={p} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
